import Iconify from "src/components/iconify";
import { PATH_PARTNER } from "src/routes/paths";

const ICONS = {
  home: <Iconify icon="akar-icons:home" />,
  clients: <Iconify icon="humbleicons:users" />,
  signatures: <Iconify icon="solar:document-text-outline" />,
};

const navConfig = [
  {
    subheader: "",
    items: [
      { title: "Home", path: PATH_PARTNER.home, icon: ICONS.home },
      { title: "Clientes", path: PATH_PARTNER.clients, icon: ICONS.clients },
      {
        title: "Planos Assinados",
        path: PATH_PARTNER.signatures,
        icon: ICONS.signatures,
      },
    ],
  },
];

export default navConfig;
